export default {
    name: 'Имя',
    tel: 'Телефон',
    save: 'Сохранить',
    confirm: 'Подтвердить',
    cancel: 'Отмена',
    delete: 'Удалить',
    complete: 'Завершить',
    loading: 'Загрузка...',
    telEmpty: 'Заполните номер телефона',
    nameEmpty: 'Пожалуйста укажите имя',
    nameInvalid: 'Некорректное имя',
    confirmDelete: 'Вы уверены, что хотите удалить?',
    telInvalid: 'Некорректный номер телефона',
    vanCalendar: {
        end: 'Конец',
        start: 'Начало',
        title: 'Календарь',
        startEnd: 'Начало/Конец',
        weekdays: ['ВС', 'ПН', 'ВТ', 'СР', 'ЧТ', 'ПТ', 'СБ'],
        monthTitle: function monthTitle(year, month) {
            return year + "/" + month;
        },
        rangePrompt: maxRange => `Укажите более ${maxRange} дней`,
    },
    vanCascader: {
        select: 'Выбрать'
    },
    vanContactCard: {
        addText: 'Добавить контакт'
    },
    vanContactList: {
        addText: 'Добавить новый контакт'
    },
    vanPagination: {
        prev: 'Назад',
        next: 'Вперед'
    },
    vanPullRefresh: {
        pulling: 'Потяните для обновления...',
        loosing: 'Отпустите для обновления...'
    },
    vanSubmitBar: {
        label: 'Всего: '
    },
    vanCoupon: {
        unlimited: 'Без ограничений',
        discount: discount => `${discount * 10}% скидка`,
        condition: condition => `Как минимум ${condition}`,
    },
    vanCouponCell: {
        title: 'Купон',
        tips: 'Нет купонов',
        count: count => `У вас есть ${count} купонов`,
    },
    vanCouponList: {
        empty: 'Нет купонов',
        exchange: 'Обмен',
        close: 'Закрыть',
        enable: 'Доступно',
        disabled: 'Недоступно',
        placeholder: 'Код купона'
    },
    vanAddressEdit: {
        area: 'Область',
        postal: 'Индекс',
        areaEmpty: 'Выберите регион доставки',
        addressEmpty: 'Адрес не может быть пустым',
        postalEmpty: 'Неверный индекс',
        defaultAddress: 'Сделать адресом по умолчанию',
        telPlaceholder: 'Телефон',
        namePlaceholder: 'Имя',
        areaPlaceholder: 'Область'
    },
    vanAddressEditDetail: {
        label: 'Адрес',
        placeholder: 'Адрес'
    },
    vanAddressList: {
        add: 'Новый адрес',
    }
};